import {
    ProductListWidgetContainer,
    mapDispatchToProps
} from 'SourceComponent/ProductListWidget/ProductListWidget.container';
import { connect } from 'react-redux';
import { getIndexedProducts } from 'Util/Product';
import { sortOutOfStockLast } from '../../util/Product/Product';
import ProductListQuery from 'Query/ProductList.query';

export class CategoryListWidgetContainer extends ProductListWidgetContainer {
    updateProductListItems(data) {
        const { productsCount, productsPerPage } = this.props;
        const {
            getBestSellCategoryWidget: {
                widget_items: items
            } = {}
        } = data;

        const totalItems = 4;
        const current_page = 1;
        const totalPages = Math.ceil(productsCount / productsPerPage);

        // Apply out-of-stock sorting on the items
        const orderedItems = sortOutOfStockLast(items);

        this.setState({
            isLoading: false,
            totalItems,
            totalPages,
            pages: { [current_page]: getIndexedProducts(orderedItems) }
        });
    }

    requestProductList(options) {
        const { categoryId, productsCount } = this.props;
        const { isNext } = options;

        if (!isNext) {
            this.updateLoadStatus(true);
        }

        this.fetchData(
            [ProductListQuery.getBestsellers(categoryId, productsCount)],
            isNext ? this.appendPage : this.updateProductListItems,
            this.onError
        );
    }

    adaptProps() {
        return {
            filter: { john: 'doe'},
            isPaginationEnabled: false
        };
    }
}

export default connect(null, mapDispatchToProps)(CategoryListWidgetContainer);
